__webpack_require__.p = "/wp-content/themes/fps22/assets/ai-seo-writer/";